"use client";

import classNames from "classnames";
import type { ReactNode } from "react";
import styles from "./DrawerBody.module.scss";

type DrawerBodyProps = {
  children: ReactNode;
  className?: string;
};

export const DrawerBody = ({ children, className }: DrawerBodyProps) => {
  return <div className={classNames(styles["comp"], className)}>{children}</div>;
};
